"use client";
import { useEffect } from "react";
import { reportBrowserError } from "@/lib/monitoring/browser";
export default function ErrorPage({error,reset}:{error:Error & {digest?:string};reset:()=>void}){
 useEffect(()=>{void reportBrowserError("react",error,{action:"Render page",route:window.location.pathname});},[error]);
 return <main className="p-8"><h1>Something went wrong</h1><p>Please try again.</p><button onClick={reset}>Try again</button></main>;
}
